import React from 'react';
import { SummaryBlock } from './components/common/SummaryBlock';
import { Spacer } from './components/common/Spacer';

export const Welcome = () => {
    return (
        <>
            <Spacer height='2em' />
            <SummaryBlock display className='text-center'>
                <h2 className='font-weight-bold'>Covid-19 Contact Tracing</h2>
            </SummaryBlock>
            <Spacer height='2em' />
            <SummaryBlock display className='text-center mt-2'>
                <h3>Please re-scan the <strong>QR code</strong><br/>
                displayed to perform <br/>
                a <strong>Visitor</strong> check in</h3>
            </SummaryBlock>
            <Spacer height="2em"/>
            <SummaryBlock display className="text-center">
                If the problem persists,<br/>
                please contact the site supervisor for further assistance.
            </SummaryBlock>
        </>
    );
}
